import script from "./repair-type-block.vue?vue&type=script&lang=ts&setup=true"
export * from "./repair-type-block.vue?vue&type=script&lang=ts&setup=true"

import "./repair-type-block.vue?vue&type=style&index=0&id=29ea3b24&lang=scss"

const __exports__ = script;

export default __exports__